import React from "react";
import { Dropdown } from "semantic-ui-react";

const nrOfTabsToDisplay = 13;

function Tabs({ setStatus, totals = [], selectedStatus,totalsLoading }) {
  

  return (
    <div className="flex--between">
      <ul className="status-nav">
        {totals.length===0&&<div>Loading totals...</div>}
        {totals.map((tab, i) => {
          
          if (i < nrOfTabsToDisplay)
            return (
              <li
                key={i}
                className={`status-nav__item   ${
                  selectedStatus === tab[0] ? "status-nav__item_active" : null
                }`}
                onClick={() =>{if(!totalsLoading) setStatus(tab[0])}}
              >
                {tab[0]}
                {!totalsLoading&&tab[1]>0&&<span className="span-text_tabs">({tab[1]})</span>}
                {totalsLoading&&selectedStatus===tab[0]&&<span className="span-text_tabs">...</span>}
              </li>
            );
        })}

        <li style={{ listStyleType: "none", marginTop: "2px" }}>
          <Dropdown
            disabled={totalsLoading}
            style={{ minWidth: "7em" }}
            className={`status-nav__item`}
            placeholder="other..."
            name="status"
            search
            // clearable
            closeOnBlur
            closeOnChange
            // selection
            value={selectedStatus}
            onChange={(e, { value }) =>{if(!totalsLoading) setStatus(value)}}
            options={totals.slice(nrOfTabsToDisplay).map(([statusName], i) => ({
              key: i,
              value: statusName,
              text: `${statusName} ${totals[nrOfTabsToDisplay+i][1]>0?totals[nrOfTabsToDisplay+i][1]:''}`,
            }))}
          />
        </li>
      </ul>

      {/* <li className="status-nav__item">Other</li> */}
    </div>

  
  );
}

export default Tabs;
